import { call, put, takeLatest } from 'redux-saga/effects';
import { salesforceActions } from '../actions/salesforceCards';
import * as api from '../api/customCards';
const { salesforceGetCardById, salesforceGetCardByIdFailed, salesforceGetCardByIdSucceeded, salesforceGetCards, salesforceGetCardsSucceeded, salesforceGetCardsFailed, salesforceTestCard, salesforceTestCardSucceeded, salesforceTestCardFailed, salesforceEditCard, salesforceEditCardSucceeded, salesforceEditCardFailed, salesforceRemoveCard, salesforceRemoveCardSucceeded, salesforceRemoveCardFailed, salesforceAddCard, salesforceAddCardSucceeded, salesforceAddCardFailed, } = salesforceActions;
export const salesforceCards = [
    takeLatest(salesforceGetCardById.toString(), genWithPromise(api.getCustomCardById, salesforceGetCardByIdSucceeded, salesforceGetCardByIdFailed)),
    takeLatest(salesforceGetCards.toString(), genWithPromise(api.getCustomCards, salesforceGetCardsSucceeded, salesforceGetCardsFailed)),
    takeLatest(salesforceTestCard.toString(), genWithPromise(api.testCustomCard, salesforceTestCardSucceeded, salesforceTestCardFailed)),
    takeLatest(salesforceEditCard.toString(), genWithPromise(api.editCustomCard, salesforceEditCardSucceeded, salesforceEditCardFailed)),
    takeLatest(salesforceRemoveCard.toString(), genWithPromise(api.removeCustomCard, salesforceRemoveCardSucceeded, salesforceRemoveCardFailed)),
    takeLatest(salesforceAddCard.toString(), genWithPromise(api.addCustomCard, salesforceAddCardSucceeded, salesforceAddCardFailed)),
];
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
